<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <!-- Minimal geometric design -->
    <g transform="rotate(-15 12 12)">
      <!-- Two overlapping circles representing 48 hours -->
      <circle cx="9" cy="12" r="7" opacity="0.3" fill="currentColor" />
      <circle cx="15" cy="12" r="7" opacity="0.3" fill="currentColor" />

      <!-- Outline circles -->
      <circle cx="9" cy="12" r="7" fill="none" />
      <circle cx="15" cy="12" r="7" fill="none" />
    </g>

    <!-- Modern 48 typography -->
    <text
      x="12"
      y="14"
      text-anchor="middle"
      font-size="8"
      font-weight="300"
      fill="currentColor"
      style="
        font-family:
          system-ui,
          -apple-system;
      "
    >
      48
    </text>

    <!-- Subtle payment indicator -->
    <circle cx="12" cy="12" r="11" fill="none" stroke-dasharray="2 3" opacity="0.5">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        from="0 12 12"
        to="360 12 12"
        dur="10s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
</template>
